import React, { useState } from 'react'
import MypageForm from '../../../components/user/MypageForm'
import MypagePwForm from '../../../components/user/MypagePwForm'

const Mypage = () => {
	const [page, setPage] = useState('default')

	return (
		<div className="mypage">
			<div className="mb-5 text-center">
				<h2 className="h2 fw-normal">개인정보 변경</h2>
			</div>

			<div className='mb-4 text-center'>
				<ul className="nav nav-tabs nav-fill">
					<li className="nav-item">
						<button type='button' className={page === 'default' ? 'nav-link active' : 'nav-link'} onClick={() => { setPage('default') }}>기본정보 변경</button>
					</li>
					<li className="nav-item">
						<button type='button' className={page === 'password' ? 'nav-link active' : 'nav-link'} onClick={() => { setPage('password') }}>비밀번호 변경</button>
					</li>
				</ul>
			</div>

			<div className='py-4'>
				{page === 'default' && <MypageForm />}
				{page === 'password' && <MypagePwForm />}
			</div>
		</div>
	)
}

export default Mypage
